import React from 'react';
import FieldManagementFormProto from "../../../proto/render/management/management-form";

import FieldRating from "../rating";
import FormManager from "../../../../gd-form/common/form-manager";
import FormRow from "../../../../gd-form/form/form-ui5/form-row";
import FormError from "../../../../gd-form/common/form-error/form-error";
import FormSelect from "../../../../gd-form/form-element/select-new/select-new";
import {FieldManagementFormProps} from "../../../render/management-form";

export default class FieldRating_ManagementForm extends FieldManagementFormProto {

    constructor(props:FieldManagementFormProps) {
        super(props);

        this.initFormData.scale = 5;

        if (this.props.field) {
            this.initFormData.scale      = _.get(this.props,'field.scale', 5);
        }

        this.formStructure.fields.scale = {
            type: 'select',
            isRequired: true,
            label: 'Scale'
        };

        // important to have it here !
        this.formStructure.onSubmit = this.onSubmit;

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit = (result:any) => {
        super.onSubmit(result);

        // @ts-ignore
        this.props.field.scale       = result.scale;

        // this.props.onSubmit(result);
        // props.field is an object so we never return anything in here
        this.props.onSubmit(this.props.field);
    }

    renderAdditionalControls() {

        const ratingTypeOptions = [
            { label: "3 Stars",   value: 3 },
            { label: "5 Stars",   value: 5 },
        ];

        return (
            <FormRow label="Scale">
                <FormSelect form={this.form} name="scale" options={ratingTypeOptions} />
                <FormError form={this.form} name="scale"/>
            </FormRow>
        )
    }
}